import { render, staticRenderFns } from "./beneficio-deficiente-visual.vue?vue&type=template&id=665deed6&"
import script from "./beneficio-deficiente-visual.vue?vue&type=script&lang=ts&"
export * from "./beneficio-deficiente-visual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665deed6')) {
      api.createRecord('665deed6', component.options)
    } else {
      api.reload('665deed6', component.options)
    }
    module.hot.accept("./beneficio-deficiente-visual.vue?vue&type=template&id=665deed6&", function () {
      api.rerender('665deed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa-deficiente-visual/beneficio-deficiente-visual.vue"
export default component.exports